/**
 * Honeybadger browser error reporting, configured from runtime config
 * (`config.json`) at bootstrap. An empty `apiKey` — the local-dev default,
 * or an unconfigured deploy — leaves reporting OFF.
 *
 * `developmentEnvironments: []` overrides the SDK's default
 * (`['dev','development','test']`) so the DEPLOYED dev SPA still reports;
 * local `npm run dev` stays off because its fallback apiKey is empty.
 *
 * Data governance: the browser key is public by design, and we attach no
 * form values / document content to notices — default breadcrumbs only.
 */
import { Honeybadger } from '@honeybadger-io/react';
import { getConfig } from './config';

let configured = false;

/** Configure Honeybadger from runtime config. Returns true when reporting is enabled. */
export function initHoneybadger(): boolean {
  const hb = getConfig().honeybadger;
  if (!hb?.apiKey) return false;
  Honeybadger.configure({
    apiKey: hb.apiKey,
    environment: hb.environment || 'production',
    developmentEnvironments: [],
    enableUncaught: true,
    enableUnhandledRejection: true,
  });
  configured = true;
  return true;
}

/** Whether {@link initHoneybadger} enabled reporting this session. */
export function isHoneybadgerConfigured(): boolean {
  return configured;
}

export { Honeybadger };
